import { render, staticRenderFns } from "./AiBookShopManage.vue?vue&type=template&id=80f774da&scoped=true"
import script from "./AiBookShopManage.vue?vue&type=script&lang=js"
export * from "./AiBookShopManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f774da",
  null
  
)

export default component.exports